import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChangeFilterValue, useChangeSearch, useFilterValue, useSearch } from '@btime/react-contexts'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'
import { SwitchWithLabel } from '../../../components/form/Switch'
import { InfoIconTooltip } from '../../../components/helpers/InfoIconTooltip'
import { Grid } from '../../../packages/kiti/components/structure/Grid'

const SearchBar = () => {
  const { t } = useTranslation('listChecklists')
  const changeSearch = useChangeSearch()
  const changeFilterValue = useChangeFilterValue()
  const ignoreProject = useFilterValue('ignoreProject', false)
  const search = useSearch()

  return (
    <>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Grid align="left" marginTop={'5px'}>
        <SwitchWithLabel
          size="small"
          noMargin
          label={t('searchOnlyThisEnvironment')}
          value={ignoreProject}
          onChange={value => changeFilterValue('ignoreProject', value)}
        />
        <InfoIconTooltip style={{ marginLeft: '5px' }} text={t('searchOnlyThisEnvironmentTooltip')} />
      </Grid>
      <Separator weight={4} />
    </>
  )
}

export default SearchBar
